<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2024-09-30 16:28:48
 * @Description:
 * @LastEditors: Please set LastEditors
-->
<template>
  <div
    v-if="showMenu"
    class="RightClickMenu absolute py-10px px-10px"
    :style="{ top: `${currentMouseLocation.y}px`, left: `${currentMouseLocation.x}px` }"
  >
    <div class="menu_list">
      <div
        class="text-[#fff] text-14px pb-5px text-center cursor-pointer px-8px py-4px"
        :class="
          activeItem === item.id
            ? 'active_class'
            : activeMouseItem === item.id
            ? 'active_class'
            : ''
        "
        v-for="item in menuList"
        :key="item.id"
        @click="handleClickMenu(item)"
        @mouseenter="handlerMouseenter(item)"
        @mouseleave="handlerMouseleave(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightClickMenu',
  data() {
    return {
      posInfo: {
        pos: [],
        code: '',
      },
      currentMouseLocation: {
        x: 0,
        y: 0,
      },
      activeItem: -1,
      activeMouseItem: -1,
      menuList: [
        {
          id: 0,
          label: '附近监控',
        },
      ],
      showMenu: false,
    }
  },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  computed: {
    clientWidth() {
      return document.documentElement.clientWidth
    },
    clientHeight() {
      return document.documentElement.clientHeight
    },
  },
  async created() {},
  async mounted() {
    if (!_.isEmpty(this.player)) {
      this.player.Native.ModelTree.EventBrowseRClick.connect(this.rightClickMsg)
      let playerDemo = document.getElementById('playerEngineId')
      playerDemo.addEventListener('click', this.handleModelDemoClick)
    }
  },
  methods: {
    /**
     * @description: 右键点击事件
     * @param {*} data
     * @return {*}
     */

    rightClickMsg(data) {
      if (data && !data.object) {
        this.showMenu = false
        return
      }
      this.activeItem = -1
      this.activeMouseItem = -1
      this.posInfo.pos = data.pos || []
      this.posInfo.code = data.object.code || ''
      // 获取可视区域的高度+宽度
      this.currentMouseLocation = {
        x: data.screen[0],
        y: data.screen[1],
      }
      this.showMenu = true
    },
    /**
     * @description: 点击事件
     * @param {*} data
     * @return {*}
     */

    async handleClickMenu(data) {
      this.activeItem = data.id
      if (data.label === '附近监控') {
        const openEvent = new CustomEvent('openComponent', {
          detail: {
            toCom: {
              code: 'NearbyCameras',
              origin: 'tag',
              name: '监控列表',
            },
            type: 'tags',
            props: this.posInfo,
          },
        })
        window.dispatchEvent(openEvent)
      }
    },
    // 鼠标移入
    handlerMouseenter(data) {
      this.activeMouseItem = data.id
    },
    // 鼠标移出
    handlerMouseleave(data) {
      this.activeMouseItem = -1
    },
    // 云渲染模型点击事件
    handleModelDemoClick(event) {
      const ePathList = event.path
      const isRouterView = _.findIndex(ePathList, (item) => {
        return item.className === 'RightClickMenu absolute p-10px'
      })
      if (isRouterView === -1) {
        this.showMenu = false
      }
      event.preventDefault()
    }
  },
  beforeDestroy() {
    let playerDemo = document.getElementById('playerEngineId')
    if(playerDemo) {
      playerDemo.removeEventListener('click', this.handleModelDemoClick);
    }
    // if (!_.isEmpty(this.player)) {
    //   this.player.Native.ModelTree.EventBrowseRClick.disconnect(this.rightClickMsg)
    // }
  },
}
</script>
<style lang="scss" scoped>
.RightClickMenu {
  border-radius: 4px;
  background-color: #0b252d !important;
  z-index: 110;
}
.menu_list {
  border-radius: 4px;
  background-color: #1d444b !important;
}
.active_class {
  background-color: rgba(0, 116, 201, 0.4);
  color: #00c0ff !important;
}
</style>
